<template>

	<!-- footer -->
	<footer class="ftco-footer ftco-section" style="background-image: url(images/footer.png);">
		<div class="container">
			<div class="row mb-5">
				<div class="col-md" v-if="contatos!=''">
					<div class="ftco-footer-widget mb-4">
						<h2 class="ftco-heading-2">Induscapas</h2>
						<p v-html="contatos[0].itiResumo1"></p>

						<ul v-if="redesSociais != ''" class="ftco-footer-social list-unstyled mt-2">
							<li v-if="redesSociais[0].itiNome != ''"><a :href="redesSociais[0].itiNome"
									target="_blank"><span class="fa fa-facebook"></span></a></li>
							<li v-if="redesSociais[0].itiReferencia != ''"><a :href="redesSociais[0].itiReferencia"
									target="_blank"><span class="fa fa-instagram"></span></a></li>
						</ul>
					</div>
				</div>
				<div class="col-md">
					<div class="ftco-footer-widget mb-4 ml-md-4">
						<h2 class="ftco-heading-2">Menu</h2>
						<ul class="list-unstyled">
							<li><router-link to="/"><span class="fa fa-chevron-right mr-2"></span>Home</router-link>
							</li>
							<li><router-link to="/quemsomos"><span class="fa fa-chevron-right mr-2"></span>Quem
									Somos</router-link></li>
							<li><router-link to="/clientes"><span
										class="fa fa-chevron-right mr-2"></span>Clientes</router-link></li>
							<li><router-link to="/noticias"><span
										class="fa fa-chevron-right mr-2"></span>Notícias</router-link></li>
							<li><router-link to="/contato"><span
										class="fa fa-chevron-right mr-2"></span>Contato</router-link></li>
						</ul>
					</div>
				</div>
				<div class="col-md">
					<div class="ftco-footer-widget mb-4">
						<h2 class="ftco-heading-2">Nossas Linhas</h2>
						<ul class="list-unstyled">
							<li v-for="menu in segmentospais" :key="menu.sgiId">
								<router-link :to="'/produtos/' + menu.sgiId + '/' + formataLink(menu.sgiNomeSegmento)"><span
										class="fa fa-chevron-right mr-2"></span>{{ menu.sgiNomeSegmento }}</router-link>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-md">
					<div class="ftco-footer-widget mb-4">
						<h2 class="ftco-heading-2">LGPD</h2>
						<div class=" mb-3">
							<ul class="list-unstyled">
								<li v-for="lgpd in informacoes" :key="lgpd.itiId">
									<router-link
										:to="'/informacoes/' + lgpd.itiId + '/' + formataLink(lgpd.itiNome)"><span
											class="fa fa-chevron-right mr-2"></span>{{ lgpd.itiNome }}</router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 text-center">
					<p>
						<a href="https://avancedigital.com.br" target="_blank">Avance Digital</a></p>
				</div>
			</div>
		</div>
	</footer>
	<!-- END footer -->

</template>

<script>
import axios from 'axios';

export default {
	name: 'PageFooter',
	components: {

	},
	data: () => ({
		textoRodape: [],
		contatos: [],
		redesSociais: [],
		marcasLista: [],
		informacoes: [],
		segmentospais: [],
		NomeCategoria: "",

	}),
	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},
	},
	created() {
		//texto e logo  
		axios.get('/Process/InsInstitucional/institucional/10/rodape/0/x')
			.then(response => {
				this.textoRodape = response.data;
				//console.log('rodapé')
				//console.log(this.textoRodape)
			})
			.catch(error => {
				console.error(error);
			});

		// contatos 
		axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
			.then(response => {
				this.contatos = response.data;
				//console.log('rodapé')
				//console.log(this.contatos)
			})
			.catch(error => {
				console.error(error);
			});

		// redes sociais 
		axios.get('/Process/InsInstitucional/institucional/20/redessociais/0/x')
			.then(response => {
				this.redesSociais = response.data;
				//console.log('redes sociais')
				//console.log(this.redesSociais)
			})
			.catch(error => {
				console.error(error);
			});

		// redes informações
		axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
			.then(response => {
				this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
			})
			.catch(error => {
				console.error(error);
			});

		axios.get('/Process/InsSegmentos/GetAll') // padrão para fazer o menu txt lateral produtos //
			.then(response => {
				this.segmentospais = response.data.filter(x => x.sgiIdPai == 0 && x.sgiVisivel).sort((a, b) => {
					const nomeA = a.sgiNomeSegmento || "";
					const nomeB = b.sgiNomeSegmento || "";
					return nomeA.localeCompare(nomeB);
				});
				//console.log('segmento pai')
				//console.log(this.segmentospais)
				this.NomeCategoria = this.segmentospais[0].sgiNomeSegmento;
			})
			.catch(error => {
				console.error(error);
			});

	},
}
</script>

<style scoped></style>